<template>
    <section id="screen-search" style="padding: 50px 0 20px; position: unset;">
        
        <div class="section-inner l-centered">
            <div class="search-request search-header" style="position: relative;">

                <div class="search-request-submit">
                    <div class="search-request-status">
                        <i @click="searchSubmit" :class="searchIconClassObject"></i>
                    </div>
                </div>
                <div class="search-request-erase" id="search-erase" v-if="request" @click="clearRequest"><i class="lnr lnr-cross"></i></div>
                <div class="search-request-holder">
                    <input v-focus v-model="request" @input="searchInputHandle" @keydown.enter="searchSubmit" type="text" placeholder="ИНН, ОГРН, ОКПО, название или ФИО" id="search-request" autocomplete="off" />
                </div>
            </div>
            
            <label style="cursor: pointer; text-align: center; display: block;">
                <input type="checkbox" v-model="raw" style="position: relative; top: 1px;">
                <h4 style="margin: 15px 0; display: inline-block;text-transform: none;font-size: 17px;color: #757575;">Исключить из результатов поиска учреждённые ЮЛ</h4>
            </label>

            <div>
                <div style="text-align: center; font-size: 12px;">
                    <span @click="() => this.helpOpened = !this.helpOpened" class="dashed">Помощь <i class="fa fa-question-circle" aria-hidden="true"></i></span>
                </div>
                <div v-if="helpOpened" style="text-align: center; margin-top: 10px; ">
                    <div class="search-help" style=" margin: 0 auto; border: solid 1px #ccc; background: #eee; border-radius: 6px; padding: 15px; max-width: 30em; font-size: 14px;text-align: left;">
                        <span style="display: inline-block; font-size: 16px; margin-bottom: 5px;">Поиск может осуществляться по следующим параметрам в любых сочетаниях:</span>
                        <span style="display: inline-block; font-weight: 700;">Для поиска юридических лиц</span>
                        <span style="display: inline-block; margin-bottom: 5px;">ИНН, ОГРН, ОКПО, краткое или полное название ЮЛ, ФИО руководителя ЮЛ (частично или полностью), ФИО совладельца ЮЛ (частично или полностью).</span>
                        <span style="display: inline-block; font-weight: 700;">Для поиска физических лиц и ИП</span>
                        <span style="display: inline-block; margin-bottom: 5px;">ИНН ФЛ, ОГРНИП, ФИО ИП/руководителя ЮЛ/совладельца ЮЛ (частично или полностью).</span>
                        <span style="display: inline-block;">Для поиска точного совпадения необходимо использовать кавычки " ". Например, "НУРАЛИЕВ БОРИС ГЕОРГИЕВИЧ", "ИНВЕСТ СТРОЙ ГРУПП"</span>
                    </div>
                </div>
            </div>

            <filters />

            <scroll-up/>

            <div v-if="searchMore" id="search-more" style="text-align: center;" class="search-header">
                <div id="search-show"></div>
                <div>
                    <div id="search-erase-all" style="display: inline-block; font-size: 14px; color: #c00; cursor: pointer; margin-bottom: 30px;"><i class="lnr lnr-cross"></i> Сбросить все настройки поиска</div>
                </div>
            </div>
        </div>
        <search-result />
    </section>
</template>

<script>
import helpers from '@/helpers.ts'
import searchResult from './searchResult.vue'
import filters from './filters.vue'
import showResultsButton from './showResultsButton.vue'
import scrollUp from '@/components/ui/scrollUp.vue'

const { formatOkved, formatCode, getQueryStringValue } = helpers

export default {
    data(){
        return { helpOpened: false }
    },
    props: {
        rows: Array
    },
    components: {
        "search-result": searchResult,
        filters,
        "scroll-up": scrollUp,
        "show-results-button": showResultsButton
    },
    computed: {
        searchMore() { return this.$store.state.search.searchMore},
        paginationState() { return this.$store.state.search.pagination },
        searchIconClassObject() {
            const loading = this.$store.state.search.loading
            return {
                lnr: true,
                "lnr-sync": loading,
                "rotating": loading,
                "lnr-magnifier": !loading
            }
        },
        request: {
            get(){
                return this.$store.state.search.filterData.request
            },
            set(value){
                this.$store.commit('search/setFilterData', { type: "request", value })
            }
        },
        raw: {
            get(){
                return this.$store.state.search.filterData.raw
            },
            set(value){
                this.$store.commit('search/setFilterData', { type: "raw", value })
            }
        }
    },
    methods: {
        searchInputHandle(){
            this.$store.commit('search/setFilterData', { type: "address", value: '' })
        },
        searchSubmit(){
            this.$store.commit('search/resetPage')
            this.$store.commit('search/updateSearchObject', { obj: 'showResultsButton', value: false })
            this.$store.dispatch('search/getCards')
        },
        clearRequest() {
            this.$store.commit('search/setFilterData', { type: 'request', value: '' })
        }
    },
    beforeCreate(){
        this.$store.commit('search/setFilterData', { type: "request", value: getQueryStringValue('request') })
        this.$store.commit('search/setFilterData', { type: "address", value: getQueryStringValue('address') })
    },
    beforeCreate(){
        this.$store.commit('search/setFilterData', { type: "request", value: getQueryStringValue('request') })
    },
    mounted() {
        this.$store.dispatch('search/getCards')
        this.$store.dispatch('search/getAllClassificators')
        //this.$store.dispatch('search/getUserSearch')
    },
    beforeDestroy() {
        this.$store.commit('search/updatePage', 1)
        this.$store.commit('search/showExportCsv', false)
    }
}
</script>

<style lang='sass'>
.search-filters-menu
	margin: 20px 0
	padding: 0
	line-height: 24px
	text-align: center

.search-result
	margin-top: 50px
	position: relative

.screen-blocker
    position: fixed
    background-color: rgba(255,255,255, 0.5)
    width: 100%
    height: 100%
    z-index: 123456789
    top: 0
    left: 0

#pagination-page
    height: 45px

.search-result-idle
    display: none !important

#screen-search
    display: block
    margin-top: 50px

.search-request-status .lnr
    vertical-align: top
    width: 56px


.fade-enter-active, .fade-leave-active
    transition: opacity .5s

.fade-enter, .fade-leave-to
    opacity: 0

#filter-license div:first-child .filters-group-outer
    border-top-right-radius: 4px
    border-top-left-radius: 4px
    border-top: 1px solid #9b979d

#filter-license .filters-group
    margin-bottom: 0

#filter-license div:last-child .filters-group-outer
    border-bottom-right-radius: 4px
    border-bottom-left-radius: 4px
    border-bottom: 1px solid #9b979d

#filter-license:after
    content: ""
    display: table
    clear: both

#filter-license .filters-group-outer
    border-radius: 0
    border: 0
    border-left: 1px solid #9b979d
    border-right: 1px solid #9b979d
    border-top: 1px solid #9b979d

.filters-group-outer
    display: inline-block
    vertical-align: middle
    width: 240px
    height: 35px
    border: solid 1px #9b979d
    border-radius: 4px
    background: #fff
    font-size: 12px
    line-height: 34px
    cursor: pointer

.filters-group-outer.active
    background: #F5D76E

.filters-group-outer select,
.filters-group-outer input
    width: 90%
    height: 100%
    text-align: center
    border: 0
    background-color: transparent

.filters-group-outer .filters-checkbox
    text-align: center


.filters-group-outer select, 
.filters-group-outer input[type="text"], 
.filters-group-outer .filters-checkbox, 
.filters-group-outer .filters-radio  
	display: block
	width: 100%
    height: 34px
    border: none
	font-family: Helvetica, Arial, sans-serif
    font-size: 12px
    font-weight: 300
    text-align: center
    line-height: 34px
    background: transparent

.filters-group-outer select, 
.filters-group-outer .filters-checkbox, 
.filters-group-outer .filters-radio
	cursor: pointer

.filters-group-outer input[type="text"].masked:focus
	text-align: left

.filters-group-outer .filters-checkbox.disabled, 
.filters-group-outer .filters-radio.disabled
	color: #eee
	cursor: default

.search-filters-menu-item__header
	font-weight: 100 !important

#search-erase.search-request-erase
    display: block
</style>
